<img src="/assets/images/queen2.svg" class="loader-logo-image" />
